import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../services/setupInterceptors";


export const fetchUserOrders = createAsyncThunk(
  "orders/fetchUserOrders",
  async (_, thunkAPI) => {
    try {
      const { data } = await axiosClient.get("/orders/user");
      if (data?.success) return data.data; 
      return thunkAPI.rejectWithValue(data?.message || "Failed to fetch orders");
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchOrderDetails = createAsyncThunk(
  "orders/fetchOrderDetails",
  async (orderId, thunkAPI) => {
    try {
      const { data } = await axiosClient.get(`/orders/${orderId}`);
      if (data?.success) return data.data; 
      return thunkAPI.rejectWithValue(data?.message || "Failed to fetch order details");
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const createOrder = createAsyncThunk(
  "orders/createOrder",
  async (payload, thunkAPI) => {
    try {
      const { data } = await axiosClient.post("/orders/create", payload);
      if (data?.success) return data.data; 
      return thunkAPI.rejectWithValue(data?.message || "Failed to create order");
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const initialState = {
  orders: [],              
  orderDetails: {},       
  status: "idle",          
  detailStatus: "idle",    
  error: null,
    createStatus: "idle",   

};


const orderSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    clearOrders: (state) => {
      state.orders = [];
      state.orderDetails = {};
      state.status = "idle";
      state.detailStatus = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserOrders.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchUserOrders.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.orders = action.payload;
      })
      .addCase(fetchUserOrders.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });

    builder
  .addCase(createOrder.pending, (state) => {
    state.createStatus = "loading";
    state.error = null;
  })
  .addCase(createOrder.fulfilled, (state, action) => {
    state.createStatus = "succeeded";
    const newOrder = action.payload;
    state.orders.unshift(newOrder);
    state.orderDetails[newOrder.id] = newOrder;
  })
  .addCase(createOrder.rejected, (state, action) => {
    state.createStatus = "failed";
    state.error = action.payload;
  });

    builder
      .addCase(fetchOrderDetails.pending, (state) => {
        state.detailStatus = "loading";
        state.error = null;
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        const order = action.payload;
        state.orderDetails[order.id] = order; 
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.error = action.payload;
      });
  },
});


export const { clearOrders } = orderSlice.actions;
export default orderSlice.reducer;
